"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

var Plugins_1 = require("./Plugins");

var unavailable = function unavailable() {
  throw new Error('Unavailable');
};

var _a = react_1.default.createContext({
  actions: {
    callSigner: unavailable,
    canCallSigner: unavailable,
    navigateTo: unavailable,
    scanQrCode: unavailable,
    send: unavailable,
    setLoading: unavailable
  },
  assets: [],
  accounts: [],
  pluginData: Plugins_1.DEFAULT_PLUGIN_DATA,
  burnerComponents: {},
  completeScan: null,
  loading: null
}),
    Provider = _a.Provider,
    Consumer = _a.Consumer;

var BurnerProvider =
/** @class */
function (_super) {
  __extends(BurnerProvider, _super);

  function BurnerProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.actions = {
      scanQrCode: _this.scanQrCode.bind(_this),
      canCallSigner: props.core.canCallSigner.bind(props.core),
      callSigner: props.core.callSigner.bind(props.core),
      send: _this.send.bind(_this),
      navigateTo: function navigateTo(location, state) {
        return Number.isInteger(location) ? props.history.go(location) : props.history.push(location, state);
      },
      setLoading: function setLoading(status) {
        return _this.setState({
          loading: status
        });
      }
    };
    _this.state = {
      accounts: [],
      completeScan: null,
      loading: null
    };
    return _this;
  }

  BurnerProvider.prototype.componentDidMount = function () {
    var _this = this;

    this.setState({
      accounts: this.props.core.getAccounts()
    });
    this.props.core.onAccountChange(function (accounts) {
      return _this.setState({
        accounts: accounts
      });
    });
  };

  BurnerProvider.prototype.scanQrCode = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var completeScan = function completeScan(result) {
        _this.setState({
          completeScan: null
        });

        if (result) {
          resolve(result);
        } else {
          reject(new Error('User canceled'));
        }
      };

      _this.setState({
        completeScan: completeScan
      });
    });
  };

  BurnerProvider.prototype.send = function (_a) {
    var asset = _a.asset,
        ether = _a.ether,
        to = _a.to,
        from = _a.from,
        message = _a.message,
        id = _a.id;

    var _from = from || this.state.accounts[0];

    var _ether = ether && ether.length > 0 ? ether : '0';

    this.props.history.push('/confirm', {
      asset: asset,
      ether: _ether,
      to: to,
      from: _from,
      message: message,
      id: id
    });
  };

  BurnerProvider.prototype.render = function () {
    var _a = this.props,
        core = _a.core,
        pluginData = _a.pluginData,
        children = _a.children,
        burnerComponents = _a.burnerComponents;
    var _b = this.state,
        accounts = _b.accounts,
        completeScan = _b.completeScan,
        loading = _b.loading;
    return react_1.default.createElement(Provider, {
      value: {
        actions: this.actions,
        accounts: accounts,
        assets: core.getAssets(),
        burnerComponents: burnerComponents,
        completeScan: completeScan,
        pluginData: pluginData,
        loading: loading
      }
    }, children);
  };

  return BurnerProvider;
}(react_1.Component);

exports.default = react_router_dom_1.withRouter(BurnerProvider);

function withBurner(WrappedComponent) {
  return function (props) {
    return react_1.default.createElement(Consumer, null, function (burnerContext) {
      return react_1.default.createElement(WrappedComponent, __assign({}, burnerContext, props));
    });
  };
}

exports.withBurner = withBurner;